var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFVentre2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 178,
    viewBox: "0 0 98 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.7733 0.246094C89.7443 17.3636 85.3577 35.939 80.8326 54.0724C77.9368 65.8007 74.9223 77.595 73.9988 89.2903C71.38 121.922 95.5491 145.722 97.086 177.246",
    stroke: "#909090",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7041 0.246094C24.0114 10.3121 16.3597 22.7397 11.1288 32.687C9.13007 36.5656 6.78836 42.1659 7.15775 46.5129C7.4348 49.8045 8.41765 53.0697 9.89524 56.0579C13.0743 63.0519 16.3785 67.8162 16.5246 75.9986C16.6499 83.0501 15.5945 88.9011 13.6552 95.5173C9.80948 108.604 9.13006 122.087 10.1459 135.63C10.977 146.863 15.8056 165.96 15.0008 177.193",
    stroke: "#909090",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.32922 91.2759C4.32922 91.2759 -2.00657 118.438 2.0205 153.941",
    stroke: "#909090",
    strokeMiterlimit: 10,
    strokeDasharray: "3.88 3.88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFVentre2);
export default __webpack_public_path__ + "static/media/F-VENTRE_2.5a3c6f862054174984c69b89282bf89c.svg";
export { ForwardRef as ReactComponent };